import React, { FC } from 'react';
import cx from 'classnames';

import useThemeBlock from '@/hooks/useThemeBlock';

import block from './block.json';
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
type HeadingProps = ThemeProps & {
	anchor?: string;
	className?: string;
	content: string;
	level: number;
};

/**
 * COMPONENT
 */
export const Heading: FC<HeadingProps> & BlockConfigs = ({
	anchor,
	className = '',
	content,
	level,
	theme = {},
}) => {
	const { blockTheme } = useThemeBlock(block.slug, theme);
	const rootClass = cx('supt-heading', getStyles(blockTheme), className);

	const HTag = `h${level}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

	return (
		<HTag
			id={anchor} // will have no id if anchor is null
			className={rootClass}
			dangerouslySetInnerHTML={{ __html: content }} // we want to parse special characters maybe (&nbsp; etc)
		/>
	);
};

Heading.slug = block.slug;
Heading.title = block.title;
